import React from 'react'
import PopLink from '@components/PopLink'
import { useAmp } from 'next/amp'
import {
  RecommendedArticles_recommendedArticles_articles_publisher,
  RecommendedArticles_recommendedArticles_articles_categories,
} from '@apollo-types/RecommendedArticles'
import {
  Container,
  ArticleImageContainer,
  ArticleImage,
  Title,
  PublisherContainer,
} from '../../MobileArticleContainer'
import { MobileDisplayContainer } from '@components/DeviceContainer'
import PopImage from '@components/PopImage'
import styled from 'styled-components'

const StyledPopImage = styled(PopImage)`
  position: relative;
  /* 0.523: 圖片 高/寬 比例 (保持 寬/高 1.91) */
  padding-top: 52%;
`
import { publicUrl } from '@libs/appUrl'

interface MobileArticleCardImage {
  url: string
  noShaper: boolean
}

interface MobileArticleCardProps {
  recommendedUrl: string
  title: string
  articleImage: MobileArticleCardImage
  publisher: RecommendedArticles_recommendedArticles_articles_publisher
  trackEnterEvent: () => void
  categories: (RecommendedArticles_recommendedArticles_articles_categories | null)[] | null
}

const MobileArticleCard = (props: MobileArticleCardProps) => {
  const isAmp = useAmp()
  const Img = isAmp ? 'amp-img' : 'img'
  const { recommendedUrl, title, trackEnterEvent, articleImage, publisher, categories } = props
  const isSecret = categories?.map((category) => category.name)?.includes('匿名聊')

  return (
    <MobileDisplayContainer>
      <Container>
        <ArticleImageContainer>
          <PopLink url={recommendedUrl} onClick={trackEnterEvent} shouldOpenInCurrentTab>
            {!isAmp ? (
              <ArticleImage>
                <StyledPopImage
                  noShaper={articleImage.noShaper}
                  imageUrl={articleImage.url}
                  sizes="calc(100vw - 30px)"
                  ratio={0.52}
                />
              </ArticleImage>
            ) : (
              <amp-img src={articleImage.url} width="100" height="52" layout="responsive" />
            )}
          </PopLink>
        </ArticleImageContainer>
        <PopLink url={recommendedUrl} onClick={trackEnterEvent} shouldOpenInCurrentTab>
          <Title>{title}</Title>
        </PopLink>
        <PublisherContainer>
          <PopLink
            url={publicUrl(`/user/${publisher?.mid}`)}
            shouldOpenInCurrentTab
            disableOnClick={isSecret}
          >
            <div className="photo-container">
              {publisher?.photoUrl && <Img src={publisher.photoUrl} width="40" height="40" />}
            </div>
            <div>
              <p className="user-name">{publisher?.name}</p>
            </div>
          </PopLink>
        </PublisherContainer>
      </Container>
    </MobileDisplayContainer>
  )
}

export default MobileArticleCard
